module.exports = __webpack_public_path__ + "static/img/5.7d27257.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/sp/5.png
// module id = HfBU
// module chunks = 0